import ContentLoader from "react-content-loader";

const TableSkeleton = () => {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={400}
      // margin
      viewBox="0 0 1000 400"
      backgroundColor="#e7cece"
      foregroundColor="#ebeceb"
    >
      {/* Header Row */}
      <rect x="10" y="20" rx="4" ry="4" width="100" height="20" />
      <rect x="150" y="20" rx="4" ry="4" width="150" height="20" />
      <rect x="350" y="20" rx="4" ry="4" width="150" height="20" />
      <rect x="550" y="20" rx="4" ry="4" width="150" height="20" />
      <rect x="750" y="20" rx="4" ry="4" width="150" height="20" />

      {/* Data Rows */}
      {[...Array(6)].map((_, i) => (
        <rect
          key={i}
          x="10"
          y={60 + i * 50}
          rx="4"
          ry="4"
          width="950"
          height="30"
        />
      ))}
    </ContentLoader>
  );
};

export default TableSkeleton;
